//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FilePicker from '@/components/FilePicker'
import Rol from '@/api/promotores/roles.api'
import MedioInformacion from '@/api/promotores/mediosinformacion.api'
import Mailchimp from '@/api/promotores/mailchimp.api'

export default {
  components: { FilePicker },

  props: {
    rol: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      rol_: {...this.rol},
      medios: [],
      listas: [],
      saving: false,
      loading: false,
    }
  },

  mounted() {
    this.loadMedioInformacion()
    this.loadMailchimpListas()
  },

  methods: {
    show() {
      this.$refs.dialog.show()
    },

    hide() {
      this.$refs.dialog.hide()
    },

    async loadMailchimpListas() {
      try {
        this.loading = true
        this.listas = await Mailchimp.lists()
      } finally {
        this.loading = false
      }
    },

    async loadMedioInformacion() {
      try {
        this.loading = true
        this.medios = await MedioInformacion.all({ columns: 'id,nombre', order: 'nombre' })
      } finally {
        this.loading = false
      }
    },

    async submit() {
      try {
        this.saving = true

        const response = await (this.rol.id 
          ? Rol.update(this.rol.id, this.rol_)
          : Rol.add(this.rol_))

        this.$emit('ok', response)
        this.hide()
      } finally {
        this.saving = false
      }
    }
  }
}
